import React, {
  Component,
  Suspense,
  Fragment,
  FunctionComponent,
  useEffect,
  useState
} from 'react';

import { useTranslation } from 'react-i18next';

import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next';
import { BrowserRouter as Router, Redirect } from 'react-router-dom';

//import Header from "../components/header/header";
import Routes from './routes';
import LoadingF3M from '../components/Loadings/LoadingF3M';

import {
  getToken,
  logout,
  getUser,
  getUsersInstitution,
  setLoading,
  getUserAndUsersInstitution,
  getInfoClient,
  getTokenRefresh,
  setRefreshInst
} from '../store/actions/login/loginActions';
import {
  loginsStorage,
  InstitutionId,
  InstitutionName,
  acessToken,
  patientIDSel,
  woundIDSel,
  AZURE_CONTAINER_NAME,
  AZURE_BLOB_NAME,
  settingsTab,
  userEmail,
  userEmailVal,
  VERSION
} from '../utils/constants';
import moment from 'moment';
import { isDefined } from '../utils/utils';

//OUTSIDE COMPONENTS
import Link from '@material-ui/core/Link';
import LinearProgress from '@material-ui/core/LinearProgress';
import Box from '@material-ui/core/Box';
import Dropdown from 'react-bootstrap/Dropdown';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
//import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';

//INSIDE COMPONENTS
import ErrorBoundary from './ErrorBoundary';
import VerticalNavBar from '../components/vertical_nav_bar/vertical_nav_bar.tsx';
import global from './../store/global.tsx';
import expandMenu from '../components/vertical_nav_bar/expandBar.tsx';
import { SecondaryFont } from '../components/header/header';
//import {CustomToggleInstitution, listOfInstitutions, SecondaryFont, ItensDropDownXsToMd} from "../components/header/header";

//CSS, STYLES & MEDIA ASSETS
import './Home.scss';
import variables from '../assets/bootstrap/scss/_variables.scss';
import secondOpinionIcon from '../utils/2ndopinionIcon.svg';
import settingsIcon from '../utils/settingsIcon.svg';
import dashboardIcon from '../utils/dashboardIcon.svg';
import PatientIcon from '../utils/account-circle.svg';
import ClearIcon from '@material-ui/icons/Clear';
import woundsIcon from '../utils/mpdswoundsIcon.svg';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Image from 'react-bootstrap/Image';
import SliderMenu from './../components/sliderMenu/sliderMenu';

const Header = React.lazy(() => import('../components/header/header'));

//Scss variable
const lgBreakpoint = variables.gridBreakLg;
const { primaryFont } = variables;
const mainText = variables.mainText;
const primaryColor = variables.primary;
const selectedprimary = variables.selectedprimary;

const useStyles = makeStyles((theme) => ({
  root: {
    '&.MuiList-root': {
      position: 'absolute',
      right: 0,
      left: 0,
      top: 120,
      [theme.breakpoints.up('sm')]: {
        top: 130
      }
    },
    '&.MuiListItem-root': {
      '&:hover': {
        background: selectedprimary
      }
    }
  },
  PaperElevation: {
    boxShadow: 'none',
    background: 'unset',
    color: mainText,
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
  },
  Menu: {
    zIndex: 2,
    width: '75%',
    background: '#FCFCFC',
    position: 'fixed',
    right: 0
  },
  MenuContainer: {
    zIndex: 2,
    right: 0,
    width: '75%'
  },
  Curtain: {
    zIndex: 10004,
    background: '#0000004d',
    top: 0,
    bottom: 0,
    position: 'fixed',
    overflowY: 'hidden'
  },
  BackgroundSideBar: {
    background: '#FCFCFC'
  },
  buttonLink: {
    color: primaryColor,
    width: 183,
    textAlign: 'left',
    height: 40,
    lineHeight: 3
  },
  selected: {
    '&.Mui-selected': {
      background: selectedprimary,
      borderLeft: 'solid',
      borderWidth: 5,
      borderColor: primaryColor,
      '&:hover': {
        background: selectedprimary
      }
    }
  },
  button: {
    '&.MuiListItem-button': {
      '&:hover': {
        background: selectedprimary
      }
    }
  }
}));

// const styles = theme => ({
//   root:{
//     '&.MuiList-root':{
//       position: 'absolute',
//       right:0,
//       left: 0,
//       top: 120,
//       [theme.breakpoints.up('sm')]: {
//         top: 130,
//       },
//     }
//
//   },
//   PaperElevation: {
//     boxShadow: 'none',
//     background: 'unset',
//     color: mainText,
//     transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
//   },
//   Menu:{
//     zIndex: 2,
//     width: '75%',
//     background: '#FCFCFC',
//     position: 'fixed',
//     right: 0
//   },
//   MenuContainer:{
//     zIndex: 2,
//     right: 0,
//     width: '75%'
//   },
//   Curtain:{
//     background: '#0000004d',
//     zIndex: 2,
//     top: 0,
//     bottom: 0,
//     position: 'fixed',
//     overflowY: 'hidden'
//   }
//
// });

const HomeHook = (props) => {
  const [currentUser, setCurrentUser] = React.useState('');
  const [showInstitutions, setShowInstitutions] = React.useState(true);
  const [selectedInstitution, setSelectedInstitution] = React.useState('');
  const [nameOfInstitution, setNameOfInstitution] = React.useState('');
  const [showUserInfo, setShowUserInfo] = React.useState(false);
  const [counter, setCounter] = React.useState(0);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [width, setWidth] = React.useState(0);
  const [height, setHeight] = React.useState(0);
  const [scrolled, setScrolled] = React.useState(false);
  const [verifyPatientOpen, setVerifyPatientOpen] = React.useState(false);
  const [pageUrl, setPageUrl] = React.useState('');
  const [changeInstitution, setChangeInstitution] = React.useState(false);
  const [isOpenExpansionInstitution, setIsOpenExpansionInstitution] = React.useState(
    false
  );
  const [isOpenExpansionUser, setIsOpenExpansionUser] = React.useState(false);
  const [showChangePassModal, setShowChangePassModal] = React.useState(false);
  const [selectedIndex, setSelectedIndex] = React.useState();

  const classes = useStyles();

  //HEADER FUNCTIONS

  const handleChangeInstitutionDropDown = (event) => {
    let chave = event.currentTarget.getAttribute('value');
    let institutionArr = chave.split('$%$');

    institutionLogin = institutionArr[0];
    nameInstitution = institutionArr[1];
    validToken = false; //mudou a instituição tem que obter novo token
    getTokenLogin = null;
    clientName = '';
    establishmentsLogin = null;
    sessionStorage.removeItem(acessToken);

    setSelectedInstitution(event.target.eventKey);
    setNameOfInstitution(institutionArr[1]);
    setChangeInstitution(true);

    localStorage.setItem(InstitutionId, institutionArr[0]);
    localStorage.setItem(InstitutionName, institutionArr[1]);

    patientIdPatient = 0;
    patientInfoPatient = null;
    medicationPatient = null;
    diagnosisPatient = null;
    woundsPatient = null;
    internmentsPatient = null;
    cardsPatient = null;
    tokenRefreshPatient = true;

    sessionStorage.setItem(patientIDSel, 0);
    sessionStorage.setItem(woundIDSel, 0);

    refreshWounds = true;
    // limpar os filtros
    listWounds = [];
    listSearchWounds = [];
    filterDateFromWounds = null;
    filterDateToWounds = null;
    filterUserInterventionWounds = null;
    filterWoundTypeWounds = null;
    filterRoomWounds = null;
    filterBedWounds = null;
    orderWounds = 'ASC';
    propertyOrderWounds = 'NextIntervention';
    pageWounds = 0;
    numberRowsPerPageWounds = 10;
    woundTypologiesWounds = [];

    woundIDwoundInfo = 0;
    isLoadingLogin = true;

    listOfAllUsersInstitutionsLogin = [];
    //this.props.login.refreshUser = true
    tokenRefeshinProgressLogin = true;
    getTokenRefresh();
    //it will close navbar menu

    if (width < 992) {
      props.toggleMenu();
    }
  };

  const editCompany = () => {
    sessionStorage.setItem(settingsTab, '1');
    let url = window.location.href;

    if (url.includes('settings')) {
      //this.props.login.refreshInst = true
      if (props.scrollNavArea) {
        props.toggleMenu();
      }
      setRefreshInst();
    } else {
      url = url.replace('/PatientDetails', '');
      url = url.replace('/wounds', '');
      url = url.replace('/#', '');
      if (url.endsWith('/')) {
        window.location.assign(url + 'settings');
      } else {
        window.location.assign(url + '/settings');
      }
    }
  };

  const onLogoutClick = () => {
    // limpar filtros
    refreshWounds = true;
    listWounds = [];
    listSearchWounds = [];
    filterDateFromWounds = null;
    filterDateToWounds = null;
    filterUserInterventionWounds = null;
    filterWoundTypeWounds = null;
    filterRoomWounds = null;
    filterBedWounds = null;
    orderWounds = 'ASC';
    propertyOrderWounds = 'NextIntervention';
    pageWounds = 0;
    numberRowsPerPageWounds = 10;
    woundIDwoundInfo = 0;
    woundTypologiesWounds = [];

    fetchUsersLogin = [];

    establishmentsLogin = null;

    sessionStorage.setItem(settingsTab, 0);

    logout();
  };

  const showChangePass = () => {
    setShowChangePassModal(!showChangePassModal);
    if (props.scrollNavArea) {
      props.toggleMenu();
    }
  };

  const confirmState = () => {
    let saveButtonCharacterisation = document.getElementById(
      'sabeButtonCharacterisation'
    );
    if (isDefined(saveButtonCharacterisation)) {
      if (!saveButtonCharacterisation.disabled) {
        return true;
      }
    }

    let saveButtonAdmin = document.getElementById('saveButtonAdmin');
    if (isDefined(saveButtonAdmin)) {
      if (!saveButtonAdmin.disabled) {
        return true;
      }
    }
    return false;
  };

  const onChangeExpandedInstitution = (v) => {
    if (!confirmState()) {
      setIsOpenExpansionInstitution(!isOpenExpansionInstitution);
    }
  };

  const onChangeExpandedUser = (v) => {
    if (!confirmState()) {
      setIsOpenExpansionUser(!isOpenExpansionUser);
    }
  };

  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
    setIsMenuOpen(false);
  };

  // class Home extends Component {
  //     constructor(props) {
  //         super(props);
  //         this.state = {
  //             currentUser: "", showInstitutions: true, selectedInstitution: "", nameOfInstitution: "", showUserInfo: false,
  //             counter: 0, isMenuOpen: false, width: 0, height: 0, scrolled: false,
  //             verifyPatientOpen: false,
  //             pageUrl: ""
  //         };
  //         this.handleClose = this.handleClose.bind(this);
  //         this.handleOpenMenu = this.handleOpenMenu.bind(this);
  //         this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  //         this.scrolledToTheFullest = this.scrolledToTheFullest.bind(this);
  //
  //         this.onClickSettingsHome = this.onClickSettingsHome.bind(this);
  //         this.onClickDashboard = this.onClickDashboard.bind(this);
  //         this.onClickWounds = this.onClickWounds.bind(this);
  //         this.onClickToggleMenu = this.onClickToggleMenu.bind(this);
  //     }

  useEffect(() => {
    if (validToken) {
      if ((clientName === '') & !getClientInProgress) {
        getClientInProgress = true;
        getInfoClient();
      }
    }

    updateWindowDimensions();
    scrolledToTheFullest();
    window.addEventListener('resize', updateWindowDimensions);
    window.addEventListener('scroll', scrolledToTheFullest);
    document.getElementById('root').style.background = '#f2f2f2';
  }, []);

  // componentDidMount() {
  //     if (this.props.login.validToken) {
  //         if (this.props.login.ClientName === "" & !this.props.login.getClientInProgress) {
  //             this.props.login.getClientInProgress = true;
  //             this.props.getInfoClient()
  //         }
  //     }
  //     this.updateWindowDimensions();
  //     this.scrolledToTheFullest();
  //     window.addEventListener('resize', this.updateWindowDimensions);
  //     window.addEventListener('scroll', this.scrolledToTheFullest);
  //     document.getElementById('root').style.background = "#f2f2f2"
  // }

  const scrolledToTheFullest = () => {
    if (
      document.body.scrollHeight <= window.scrollY + window.innerHeight ||
      document.body.scrollHeight - 1 <= window.scrollY + window.innerHeight
    ) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  // scrolledToTheFullest() {
  //     if (document.body.scrollHeight <= window.scrollY + window.innerHeight || document.body.scrollHeight - 1 <= window.scrollY + window.innerHeight) {
  //         this.setState({
  //             scrolled: true
  //         });
  //     } else {
  //         this.setState({
  //             scrolled: false
  //         });
  //     }
  // }

  const updateWindowDimensions = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);

    if (width > lgBreakpoint) {
      setIsMenuOpen(false);
    }
  };

  // updateWindowDimensions() {
  //     this.setState({ width: window.innerWidth, height: window.innerHeight });
  //     if (this.state.width > lgBreakpoint) {
  //         this.setState({
  //             isMenuOpen: false
  //         });
  //     }
  // }

  useEffect(() => {
    if (
      tokenRefreshWounds ||
      tokenRefreshPatient ||
      tokenRefreshWoundInfo ||
      needTokenRefresh
    ) {
      tokenRefreshWounds = false;
      tokenRefreshPatient = false;
      tokenRefreshWoundInfo = false;
      needTokenRefresh = false;
      getTokenRefresh();
    } else if (!validToken) {
      refreshToken();
    } else {
      let lista = listOfUsersInstitution || [];
      if (!userInfo) {
        if (localStorage.getItem(userEmail) != null) {
          getUser();
        }
      } else if (!getClientInProgress && clientName === '') {
        getClientInProgress = true;
        getInfoClient();
      } else if (lista.length === 0) {
        if (!getUsersInProgressLogin && !getUsersDoneLogin) {
          getUsersInProgressLogin = true;
          getUsersInstitution();
        }
      } else if (validateUserAcessInLogin) {
        let email = localStorage.getItem(userEmailVal);
        let url = window.location.href;

        if (email !== emailLogin) {
          if (!userAcessWounds && userAcessSettings) {
            if (!url.includes('settings')) {
              setPageUrl('/wounds');
            } else if (url.includes('settings')) {
              setPageUrl('');
            }
          }

          localStorage.setItem(userEmailVal, emailLogin);
        }

        validateUserAcessLogin = false;
      } else if (
        !verifyPatientOpen &&
        loginExtPatientLogin != null &&
        loginExtPatientLogin !== 'null' &&
        loginExtPatientLogin !== ''
      ) {
        if (userAcessWounds) {
          setPageUrl('/wounds');
        }
      }
    }

    //Unmount
    return () => {
      window.removeEventListener('resize', updateWindowDimensions);
      window.removeEventListener('scroll', scrolledToTheFullest);
    };
  });

  // componentDidUpdate() {
  //     if (this.props.wounds.TokenRefresh || this.props.patient.TokenRefresh || this.props.woundInfo.TokenRefresh || this.props.login.needTokenRefresh) {
  //         this.props.wounds.TokenRefresh = false;
  //         this.props.patient.TokenRefresh = false;
  //         this.props.woundInfo.TokenRefresh = false;
  //         this.props.login.needTokenRefresh = false;
  //         this.props.getTokenRefresh();
  //     } else if (!this.props.login.validToken) {
  //         this.refreshToken();
  //     }
  //     else {
  //         let lista = this.props.login.listOfUsersInstitution || []
  //         if (!this.props.login.userInfo) {
  //             if (localStorage.getItem(userEmail) != null) {
  //                 this.props.getUser();
  //             }
  //         } else if (!this.props.login.getClientInProgress && this.props.login.ClientName === "") {
  //             this.props.login.getClientInProgress = true
  //             this.props.getInfoClient()
  //         } else if (lista.length === 0) {
  //             if (!this.props.login.getUsersInProgress && !this.props.login.getUsersDone) {
  //                 this.props.login.getUsersInProgress = true;
  //                 this.props.getUsersInstitution();
  //             }
  //         } else if (this.props.login.validateUserAcessInLogin) {
  //             let email = localStorage.getItem(userEmailVal)
  //             let url = window.location.href;
  //
  //             if (email !== this.props.login.email) {
  //                 if (!this.props.login.userAcess.wounds && this.props.login.userAcess.settings) {
  //                     if (!url.includes("settings")) {
  //                         /* url = url.replace("/#", "")
  //                         url = url.replace("/PatientDetails", "")
  //                         url = url.replace("/wounds", "")
  //                         if (url.endsWith("/")) {
  //                             window.location.assign(url + "settings")
  //                         } else {
  //                             window.location.assign(url + "/settings")
  //                         }
  //                         this.setState({
  //                             pageUrl: "/settings"
  //                         })
  //                     }
  //                 } else {
  //                     if (this.props.login.loginExtPatient != null && this.props.login.loginExtPatient !== "null" && this.props.login.loginExtPatient !== "") {
  //                         /* url = url.replace("/settings", "")
  //                         url = url.replace("/#", "")
  //                         if (!url.includes("/wounds")) {
  //                             if (url.endsWith("/")) {
  //                                 url = url + "wounds"
  //                             } else {
  //                                 url = url + "/wounds"
  //                             }
  //                         }
  //                         window.location.assign(url) */
  //
  //                         this.setState({
  //                             pageUrl: "/wounds"
  //                         })
  //
  //                     } else if (url.includes("settings")) {
  //                         //window.location.assign(url.replace("settings", ""))
  //
  //                         this.setState({
  //                             pageUrl: ""
  //                         })
  //                     }
  //                 }
  //
  //                 localStorage.setItem(userEmailVal, this.props.login.email)
  //             }
  //
  //             this.props.login.validateUserAcess = false
  //         } else if (!this.state.verifyPatientOpen && (this.props.login.loginExtPatient != null && this.props.login.loginExtPatient !== "null" && this.props.login.loginExtPatient !== "")) {
  //             if (this.props.login.userAcess.wounds) {
  //                 /* let url = window.location.href;
  //
  //                 url = url.replace("/settings", "")
  //                 url = url.replace("/#", "")
  //                 if (!url.includes("/wounds")) {
  //                     if (url.endsWith("/")) {
  //                         url = url + "wounds"
  //                     } else {
  //                         url = url + "/wounds"
  //                     }
  //                 }
  //                 window.location.assign(url) */
  //
  //                 this.setState({
  //                     pageUrl: "/wounds"
  //                 })
  //             }
  //         }
  //     }
  //
  // }

  // componentWillUnmount() {
  //     window.removeEventListener('resize', this.updateWindowDimensions);
  //     window.removeEventListener('scroll', this.scrolledToTheFullest);
  // }

  const handleOpenMenu = (prevState) => {
    if (!isMenuOpen) {
      // refresh user information to update user photo
      getUser();
    }

    console.log('CLICKED');

    //setIsMenuOpen(!prevState.isMenuOpen)
    setIsMenuOpen(true);
  };

  // handleOpenMenu() {
  //     if (!this.state.isMenuOpen) {
  //         // refresh user information to update user photo
  //         this.props.getUser();
  //     }
  //     this.setState(prevState => ({
  //         isMenuOpen: !prevState.isMenuOpen
  //     }));
  // }

  const refreshToken = () => {
    if (emailLogin != null && passLogin != null && institutionLogin != null) {
      getToken(passLogin);
    }
  };

  // refreshToken() {
  //     if (
  //         this.props.login.email != null &&
  //         this.props.login.pass != null &&
  //         this.props.login.institution != null
  //     ) {
  //         this.props.getToken(this.props.login.pass);
  //     }
  // }

  const handleClose = () => {
    getUser();
    setShowUserInfo(false);
  };

  // handleClose() {
  //     this.props.getUser();
  //
  //     this.setState({
  //         showUserInfo: false
  //     });
  // }

  const confirmStateHome = () => {
    let saveButtonCharacterisation = document.getElementById(
      'sabeButtonCharacterisation'
    );
    if (isDefined(saveButtonCharacterisation)) {
      if (!saveButtonCharacterisation.disabled) {
        return true;
      }
    }

    let saveButtonAdmin = document.getElementById('saveButtonAdmin');
    if (isDefined(saveButtonAdmin)) {
      if (!saveButtonAdmin.disabled) {
        return true;
      }
    }
    return false;
  };

  // confirmStateHome() {
  //     let saveButtonCharacterisation = document.getElementById("sabeButtonCharacterisation");
  //     if (isDefined(saveButtonCharacterisation)) {
  //         if (!saveButtonCharacterisation.disabled) {
  //             return true;
  //         }
  //     }
  //
  //     let saveButtonAdmin = document.getElementById("saveButtonAdmin");
  //     if (isDefined(saveButtonAdmin)) {
  //         if (!saveButtonAdmin.disabled) {
  //             return true;
  //         }
  //     }
  //     return false;
  // }

  const onClickSettingsHome = () => {
    if (!confirmStateHome()) {
      let url = window.location.href;
      setPageUrl('/settings');
    }
  };

  // onClickSettingsHome() {
  //     if (!this.confirmStateHome()) {
  //         let url = window.location.href;
  /* if (url.includes("settings")) {

            } else {
                url = url.replace("/PatientDetails", "")
                url = url.replace("/wounds", "")
                url = url.replace("/#", "")
                if (url.endsWith("/")) {
                    window.location.assign(url + "settings")
                } else {
                    window.location.assign(url + "/settings")
                }
            } */

  //         this.setState({
  //             pageUrl: "/settings"
  //         })
  //
  //     }
  // }

  const onClickWounds = () => {
    if (!confirmStateHome()) {
      let url = window.location.href;
      setPageUrl('/wounds');
    }
  };

  // onClickWounds() {
  //     if (!this.confirmStateHome()) {
  //         let url = window.location.href;
  /* if (url.includes("wounds")) {

            } else {
                url = url.replace("/PatientDetails", "")
                url = url.replace("/settings", "")
                url = url.replace("/#", "")
                if (url.endsWith("/")) {
                    window.location.assign(url + "wounds")
                } else {
                    window.location.assign(url + "/wounds")
                }
            } */
  //
  //         this.setState({
  //             pageUrl: "/wounds"
  //         })
  //     }
  // }

  const onClickDashboard = () => {
    if (!confirmStateHome()) {
      setPageUrl('/');
    }
  };

  // onClickDashboard() {
  //     if (!this.confirmStateHome()) {
  /*             let url = window.location.href;

                        url = url.replace("/PatientDetails", "")
                        url = url.replace("/settings", "")
                        url = url.replace("/wounds", "")
                        url = url.replace("/#", "")
                        window.location.assign(url) */

  //         this.setState({
  //             pageUrl: "/"
  //         })
  //     }
  // }

  const onClickToggleMenu = () => {
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }
  };

  // onClickToggleMenu() {
  //   if (this.state.isMenuOpen) {
  //     this.setState({
  //         isMenuOpen: false
  //     });
  //   }
  // }

  const { t } = useTranslation();
  //const { t } = this.props;

  let year = moment().format('YYYY');

  //const { classes } = this.props;

  let tabs = [];

  //REDUCERS
  let userAcess = useSelector((state) => state.login.userAcess);

  let userAcessWounds = useSelector((state) => state.login.userAcess.wounds);
  let userAcessSettings = useSelector((state) => state.login.userAcess.settings);

  let listOfInstitutions = useSelector((state) => state.login.listOfInstitutions);
  let isLoadingLogin = useSelector((state) => state.login.isLoading);
  let isLoadingWoundInfo = useSelector((state) => state.woundInfo.isLoading);
  let isLoadingPatient = useSelector((state) => state.patient.isLoading);
  let validToken = useSelector((state) => state.login.validToken);
  let clientName = useSelector((state) => state.login.ClientName);
  let clientNIF = useSelector((state) => state.login.ClientNIF);
  let getClientInProgress = useSelector((state) => state.login.getClientInProgress);
  let tokenRefreshPatient = useSelector((state) => state.patient.TokenRefresh);
  let tokenRefreshWounds = useSelector((state) => state.wounds.TokenRefresh);
  let tokenRefreshLogin = useSelector((state) => state.login.TokenRefresh);
  let tokenRefreshWoundInfo = useSelector((state) => state.woundInfo.TokenRefresh);
  let needTokenRefresh = useSelector((state) => state.login.needTokenRefresh);
  let listOfUsersInstitution = useSelector((state) => state.login.listOfUsersInstitution);
  let userInfo = useSelector((state) => state.login.userInfo);
  let emailLogin = useSelector((state) => state.login.email);
  let nameInstitution = useSelector((state) => state.login.nameInstitution);
  let institutionLogin = useSelector((state) => state.login.institution);
  let userPhotoUriLogin = useSelector((state) => state.login.userPhotoUri);
  let userNameLogin = useSelector((state) => state.login.userName);
  let getTokenLogin = useSelector((state) => state.login.getToken);
  let establishmentsLogin = useSelector((state) => state.login.establishments);
  let userSpecialityLogin = useSelector((state) => state.login.userSpeciality);
  let patientIdPatient = useSelector((state) => state.patient.PatientID);
  let patientInfoPatient = useSelector((state) => state.patient.PatientInfo);
  let medicationPatient = useSelector((state) => state.patient.Medication);
  let diagnosisPatient = useSelector((state) => state.patient.Diagnosis);
  let woundsPatient = useSelector((state) => state.patient.Wounds);
  let internmentsPatient = useSelector((state) => state.patient.Internments);
  let cardsPatient = useSelector((state) => state.patient.Cards);
  let refreshWounds = useSelector((state) => state.wounds.Refresh);
  let listWounds = useSelector((state) => state.wounds.list);
  let listSearchWounds = useSelector((state) => state.wounds.listSearch);
  let filterDateFromWounds = useSelector((state) => state.wounds.FilterDateFrom);

  let filterDateToWounds = useSelector((state) => state.wounds.FilterDateTo);
  let filterUserInterventionWounds = useSelector(
    (state) => state.wounds.FilterUserIntervention
  );
  let filterWoundTypeWounds = useSelector((state) => state.wounds.FilterWoundType);
  let filterRoomWounds = useSelector((state) => state.wounds.FilterRoom);
  let filterBedWounds = useSelector((state) => state.wounds.FilterBed);
  let orderWounds = useSelector((state) => state.wounds.Order);
  let propertyOrderWounds = useSelector((state) => state.wounds.PropertyOrder);
  let pageWounds = useSelector((state) => state.wounds.Page);
  let numberRowsPerPageWounds = useSelector((state) => state.wounds.NumberRowsPerPage);
  let woundIDwoundInfo = useSelector((state) => state.woundInfo.WoundID);
  let woundTypologiesWounds = useSelector((state) => state.wounds.WoundTypologies);
  let fetchUsersLogin = useSelector((state) => state.login.fetchUsers);

  let getUsersInProgressLogin = useSelector((state) => state.login.getUsersInProgress);
  let getUsersDoneLogin = useSelector((state) => state.login.getUsersDoneLogin);

  let validateUserAcessInLogin = useSelector(
    (state) => state.login.validateUserAcessInLogin
  );

  let listOfAllUsersInstitutionsLogin = useSelector(
    (state) => state.login.listOfAllUsersInstitutions
  );

  let tokenRefeshinProgressLogin = useSelector(
    (state) => state.login.tokenRefeshinProgress
  );

  let validateUserAcessLogin = useSelector((state) => state.login.validateUserAcess);
  let loginExtPatientLogin = useSelector((state) => state.login.loginExtPatient);

  let passLogin = useSelector((state) => state.login.pass);

  let listOfInstitutionsArray = JSON.parse(listOfInstitutions) || [];

  const CustomToggleInstitution = React.forwardRef(({ children, onClick }, ref) => (
    <a
      className='text-decoration-none font-weight-bold d-block'
      ref={ref}
      href=''
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <Box
        fontFamily={SecondaryFont}
        fontWeight={700}
        fontSize={14}
        className='inst-dropdown d-block'
      >
        {nameInstitution}{' '}
        <ExpandMoreIcon
          className='my-auto'
          fontSize='large'
          color={
            listOfInstitutionsArray.length > 1 || userAcess.settings
              ? 'inherit'
              : 'disabled'
          }
        />
      </Box>
    </a>
  ));

  const itemDashboard = {
    link: '/',
    icon: (
      <IconButton
        color='primary'
        size='small'
        aria-
        label='f3m'
        className='align-text-top'
        onClick={onClickDashboard}
      >
        <Image fluid className='my-auto' src={dashboardIcon} alt='logo' />
      </IconButton>
    ),
    itemTitle: (
      <Box
        fontSize={14}
        fontWeight={700}
        fontFamily='Nunito'
        className={`my-auto pl-3 text-uppercase ${classes.buttonLink}`}
        onClick={onClickDashboard}
      >
        {t('Dashboard.DashboardTitle')}
      </Box>
    )
  };

  const itemSettings = {
    link: '/settings',
    icon: (
      <IconButton
        color='primary'
        size='small'
        aria-label='f3m'
        className='align-text-top'
        onClick={onClickSettingsHome}
      >
        {/* <SettingsIcon fontSize="large" /> */}
        <Image fluid src={settingsIcon} alt='logo' />
      </IconButton>
    ),
    itemTitle: (
      <Box
        fontSize={14}
        fontWeight={700}
        fontFamily='Nunito'
        className={`my-auto pl-3 text-uppercase ${classes.buttonLink}`}
        onClick={onClickSettingsHome}
      >
        {t('navBar.Admin')}
      </Box>
    )
  };

  const itemWounds = {
    link: '/wounds',
    icon: (
      <IconButton
        color='primary'
        size='small'
        aria-label='f3m'
        className='align-text-top'
        onClick={onClickWounds}
      >
        <Image fluid className='my-auto' src={woundsIcon} alt='logo' />
      </IconButton>
    ),
    itemTitle: (
      <Box
        fontSize={14}
        fontWeight={700}
        fontFamily='Nunito'
        className={`my-auto pl-3 text-uppercase ${classes.buttonLink}`}
        onClick={onClickWounds}
      >
        {t('navBar.wounds')}
      </Box>
    )
  };

  const itemSecondOpinion = {
    link: '/SecondOpinion',
    icon: (
      <IconButton
        color='primary'
        size='small'
        aria-label='f3m'
        className='align-text-top' /* onClick={this.onClickSettings} */
      >
        <Image fluid className='my-auto' src={secondOpinionIcon} alt='logo' />
      </IconButton>
    )
  };

  tabs.push(itemDashboard);

  if (userAcessWounds) {
    tabs.push(itemWounds);
  }
  if (userAcessSettings) {
    tabs.push(itemSettings);
  }

  let url = window.location.href;
  let useRedirect = false;

  if (pageUrl !== '' && pageUrl !== '/') {
    if (url.includes('/PatientDetails') && pageUrl.includes('wounds')) {
      useRedirect = false;
    } else {
      useRedirect = !url.includes(pageUrl);
    }
  } else if (pageUrl == '/') {
    if (
      url.includes('/PatientDetails') ||
      url.includes('/settings') ||
      url.includes('/wounds')
    ) {
      useRedirect = true;
    }
  }

  return (
    <ErrorBoundary>
      <Router>
        <VerticalNavBar itens={tabs} />

        <div className={isMenuOpen ? `overflow-y-hidden` : `h-100 padding-vertical-nav`}>
          <Suspense fallback={<LinearProgress />}>
            {isMenuOpen ? (
              <div className={`${classes.Curtain} h-100 w-100`}>
                <SliderMenu className={` position-fixed ${classes.MenuContainer} h-100`}>
                  <div className={`h-100 position-absolute ${classes.Menu} bottom-0`}>
                    <div>
                      <IconButton
                        size='small'
                        className='float-right mt-4 mr-3 mt-md-4 mr-md-4'
                        onClick={onClickToggleMenu}
                      >
                        <ClearIcon fontSize='large' />
                      </IconButton>

                      <List className={`${classes.root}`}>
                        {tabs.map((item, index) => (
                          <ListItem
                            button
                            disableRipple
                            disableTouchRipple
                            disableFocusRibble
                            className={`py-3 d-flex ${classes.selected} ${classes.root} ${classes.button}`}
                            selected={selectedIndex === index}
                            onClick={(event) => handleListItemClick(event, index)}
                          >
                            <ListItemIcon>{item.icon}</ListItemIcon>
                            <Box
                              fontSize={18}
                              fontWeight={700}
                              fontFamily='Nunito'
                              className={`my-auto text-uppercase ${classes.buttonLink}`}
                            >
                              {item.itemTitle}
                            </Box>
                          </ListItem>
                        ))}
                      </List>
                      <div
                        className={`position-absolute bottom-0 w-100 ${classes.BackgroundSideBar}`}
                      >
                        <ExpansionPanel
                          className={`PaperElevation d-lg-none mt-5 border-expand-menu py-3 mx-4 ${classes.PaperElevation}`}
                          expanded={isOpenExpansionInstitution}
                          onChange={(v) => onChangeExpandedInstitution(v)}
                        >
                          <ExpansionPanelSummary
                            expandIcon={
                              <ExpandMoreIcon
                                color={
                                  listOfInstitutionsArray.length > 1 || userAcess.settings
                                    ? 'inherit'
                                    : 'disabled'
                                }
                              />
                            }
                            aria-controls='panel1a-content'
                            id='panel1a-header'
                          >
                            <Box
                              fontFamily={SecondaryFont}
                              fontWeight={700}
                              fontSize={18}
                              className='inst-dropdown d-block break-text'
                            >
                              {nameInstitution}
                            </Box>
                          </ExpansionPanelSummary>
                          <ExpansionPanelDetails
                            className='flex-column no-padding-y pb-4 pl-5 ml-5'
                            hidden={
                              !(listOfInstitutionsArray.length > 1 || userAcess.settings)
                            }
                          >
                            <Link
                              className='institution-item d-block py-3 cursor-pointer'
                              hidden={!userAcess.settings}
                              onClick={editCompany}
                            >
                              {t('EditCompany')}
                            </Link>
                            {listOfInstitutionsArray.map((item, key) => (
                              <Fragment key={item.rowKey}>
                                <Link
                                  className='cursor-pointer font-weight-bold institution-item d-block py-3 break-text'
                                  key={item.rowKey}
                                  value={`${item.rowKey}$%$${item.name}`}
                                  onClick={handleChangeInstitutionDropDown}
                                  hidden={institutionLogin === item.rowKey}
                                >
                                  {item.name}
                                </Link>
                              </Fragment>
                            ))}
                          </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel
                          className={`d-lg-none d-lg-none border-expand-menu py-3 mx-4 mb-5 ${classes.PaperElevation}`}
                          expanded={isOpenExpansionUser}
                          onChange={(v) => onChangeExpandedUser(v)}
                        >
                          <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls='panel1a-content'
                            id='panel1a-header'
                          >
                            <Image
                              id='bannerImage2'
                              className={
                                'mr-4 my-auto fit-photo' +
                                (userPhotoUriLogin === '' || userPhotoUriLogin === null
                                  ? ''
                                  : ' border-image-header')
                              }
                              roundedCircle
                              width='45'
                              height='45'
                              src={
                                userPhotoUriLogin === '' || userPhotoUriLogin == null
                                  ? PatientIcon
                                  : userPhotoUriLogin
                              }
                              onError={(event) => {
                                event.target.src = PatientIcon;
                                event.target.className = 'mr-4 my-auto';
                              }}
                            ></Image>
                            <div className='id-dropdown-parent text-left my-auto mr-1 '>
                              <Box
                                fontFamily={SecondaryFont}
                                fontWeight={700}
                                fontSize={18}
                                className=' d-block'
                              >
                                {userNameLogin}
                              </Box>
                              <Box
                                fontFamily={SecondaryFont}
                                fontSize={18}
                                className='id-dropdown m-0'
                              >
                                {userSpecialityLogin}
                              </Box>
                            </div>
                          </ExpansionPanelSummary>
                          <ExpansionPanelDetails className='no-padding-y pb-4 pl-5 ml-5 flex-column'>
                            <Link
                              className='institution-item d-block py-3 cursor-pointer'
                              onClick={onLogoutClick}
                            >
                              {t('Login.Logout')}
                            </Link>
                            <Link
                              className='institution-item d-block py-3 cursor-pointer'
                              onClick={showUserInfo}
                            >
                              {t('PersonalInfo')}
                            </Link>
                            <Link
                              className='institution-item d-block py-3 cursor-pointer'
                              onClick={showChangePass}
                            >
                              {t('Login.ChangePass')}
                            </Link>
                          </ExpansionPanelDetails>
                        </ExpansionPanel>
                      </div>
                    </div>
                  </div>
                </SliderMenu>
              </div>
            ) : (
              ''
            )}

            {useRedirect ? <Redirect push to={pageUrl} /> : <></>}

            <LoadingF3M
              hidden={!isLoadingLogin && !isLoadingWoundInfo && !isLoadingPatient}
            />

            <div className='position-relative min-h-100'>
              <Suspense fallback={<LoadingF3M />}>
                <Header scrollNavArea={isMenuOpen} toggleMenu={handleOpenMenu}>
                  {props}
                </Header>
              </Suspense>

              <div hidden={!validToken}>
                <Routes acess={userAcess} />
              </div>

              <div
                className={`footer px-4 position-fixed ${
                  scrolled ? ' ' : 'footer-box-shadow'
                } w-100 bottom-0 pt-2`}
                hidden={clientName === ''}
              >
                <Box
                  color='#b3adad'
                  fontSize={9}
                  fontFamily={primaryFont}
                  fontWeight={700}
                  className='sm-footer d-inline font-weight-bold float-left'
                >
                  {t('Licensed')}:{' '}
                  <label style={{ textTransform: 'uppercase' }}>{clientName}</label> |{' '}
                  {t('taxpayer')}: {clientNIF}
                </Box>

                <Box
                  color='#b3adad'
                  fontSize={9}
                  fontFamily={primaryFont}
                  fontWeight={700}
                  className='sm-footer font-weight-bold d-inline float-right pb-md-0 pb-2'
                >
                  Copyright &#169; {year}{' '}
                  <Link
                    color='textSecondary'
                    className='font-weight-bold'
                    href={t('urlF3MSite')}
                    target='_blank'
                  >
                    F3M - Information Systems, S.A.
                  </Link>{' '}
                  | V {VERSION}
                </Box>
              </div>
            </div>
          </Suspense>
        </div>
      </Router>
    </ErrorBoundary>
  );
};

// const mapStateToProps = state => ({ login: state.login, wounds: state.wounds, patient: state.patient, woundInfo: state.woundInfo });
// const mapDispatchToProps = dispatch => bindActionCreators({ logout, getToken, getUser, getUsersInstitution, setLoading, getUserAndUsersInstitution, getInfoClient, getTokenRefresh }, dispatch)

// export default withTranslation()(connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(withStyles(styles)(Home)));

export default HomeHook;
